module.exports = __webpack_public_path__ + "static/ec-os-final-analysis-km-curve-desktop_v06-95e1794f8e5ce6981f434892de32fe4f.png";